import { Modal } from '@fortress-technology-solutions/fortress-component-library/Molecules_Fortress';
import useIntl from '../../../hooks/useIntl';
import messages from './messages';
import rentForecastMessages from '../messages';
import { FormattedMessage } from 'react-intl';
import React, { useCallback, useState } from 'react';
import { approveBudget } from './hooks.useQuery';
import useSelectedProperty from '../../../hooks/useSelectedProperty';
import { toastr } from 'react-redux-toastr';

type Props = {
  open: boolean,
  closeModal: () => void,
  rentForecastId: string,
  reloadRentForecastList: () => void,
};

const ApproveBudgetModal = ({
  open,
  closeModal,
  rentForecastId,
  reloadRentForecastList,
}: Props) => {
  const intl = useIntl();
  const property = useSelectedProperty();
  const [submitting, setSubmitting] = useState(false);

  const onClose = () => {
    if (!submitting) {
      closeModal();
    }
  };

  const approveCurrentBudget = useCallback(async () => {
    setSubmitting(true);

    try {
      await approveBudget(property.organizationId, property.id, rentForecastId);
      reloadRentForecastList();

      toastr.success(
        intl.formatMessage(rentForecastMessages.success),
        intl.formatMessage(messages.saveSuccess),
      );

      closeModal();
    } catch (error) {
      console.error(error);
      toastr.error(
        intl.formatMessage(rentForecastMessages.error),
        intl.formatMessage(messages.saveFailed),
      );
    } finally {
      setSubmitting(false);
    }
  }, [rentForecastId, property, closeModal, intl, reloadRentForecastList]);

  return (
    <Modal
      open={open}
      onClose={onClose}
      title={intl.formatMessage(messages.approveBudgetTitle)}
      actionsProps={[
        {
          children: intl.formatMessage(rentForecastMessages.cancel),
          onClick: onClose,
        },
        {
          children: intl.formatMessage(rentForecastMessages.confirmOnly),
          onClick: approveCurrentBudget,
          submitButton: true,
          isSubmitting: submitting,
        },
      ]}
      ModalProps={{
        PaperProps: {
          sx: {
            width: {
              xs: 'calc(100% - 32px)',
              sm: 540,
            },
            maxHeight: 'calc(100vh - 100px)',
          },
        },
      }}
    >
      <FormattedMessage {...messages.approveBudgetText} />
    </Modal>
  );
};

export default ApproveBudgetModal;
